module.exports = __webpack_public_path__ + "img/usb.ba3ade79.png";